import React from 'react';
import Header from 'components/commercetools-ui/aafes/miniHeader';

function MiniHeaderTastic({ data }) {
  return <Header data={data} />;
}

export default MiniHeaderTastic;
